import { getEnv } from "@/hooks/useEnv";

export const useAppVersion = () => {
  const version = getEnv("VITE_RELEASE_TAG");
  if (!version) return null;
  return version;
};
